<div class="d-flex flex-column vh-100">
    <static-hdr></static-hdr>

    <section class="=flex-grow-1">
        <div class="h-100">
            <div class="card-body">

                <h5 class="title px-5 mb-5">تواصل معنا</h5>

                <div class="row justify-content-between  px-5">
                    <div class="col-md-6">

                        <div class="row">
                            <div class="col-md-12 col-xl-6">
                                <div class="d-flex flex-column">
                                    <div class="d-flex gap-2 flex-column">
                                        <div class="d-flex m align-items-center">
                                            <img class="contact-icon" class="mt-2"
                                                src="/assets/common/images/formlabel.svg" alt="at" />
                                            <span class="font-weight-bolder h6">الاسم بالكامل</span>
                                        </div>
                                        <div>
                                            <input type="text" placeholder="أدخل الاسم بالكامل"
                                                class="form-control bg-gray-100 p-3" [(ngModel)]="submission.fullName"
                                                name="fullName" maxlength="200">
                                            <div class="d-flex justify-content-end mt-1">
                                                <small [class.text-danger]="(submission.fullName?.length || 0) >= 200"
                                                    class="text-muted">
                                                    {{ submission.fullName?.length || 0 }} / 200
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex gap-2 mt-5 flex-column">
                                        <div class="d-flex m align-items-center">
                                            <img class="contact-icon" class="mt-2"
                                                src="/assets/common/images/formlabel.svg" alt="at" />
                                            <span class="font-weight-bolder h6">البريد الالكتروني</span>
                                        </div>
                                        <div>
                                            <input type="email" placeholder="ادخل البريد الالكتروني "
                                                class="form-control bg-gray-100 p-3" [(ngModel)]="submission.email"
                                                name="email" maxlength="200">
                                            <div class="d-flex justify-content-end mt-1">
                                                <small [class.text-danger]="(submission.email?.length || 0) >= 200"
                                                    class="text-muted">
                                                    {{ submission.email?.length || 0 }} / 200
                                                </small>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                            </div>
                            <div class="col-md-12 col-xl-6 mt-5 mt-xl-0">
                                <div class="d-flex flex-column">
                                    <!-- <div class="d-flex gap-2 flex-column">
                                    <div class="d-flex m align-items-center">
                                        <img class="contact-icon" class="mt-2" src="/assets/common/images/formlabel.svg" alt="at" />
                                        <span class="font-weight-bolder h6">الاسم الأخير</span>
                                    </div>
                                    <div>
                                        <input type="text" placeholder="أدهل الاسم الأخير" class="form-control bg-gray-100 p-3">
                                    </div>
                                </div> -->
                                    <div class="d-flex gap-2 flex-column">
                                        <div class="d-flex m align-items-center">
                                            <img class="contact-icon" class="mt-2"
                                                src="/assets/common/images/formlabel.svg" alt="at" />
                                            <span class="font-weight-bolder h6">رقم الجوال</span>
                                        </div>
                                        <div class="d-flex">
                                            <div class="btn-group" dropdown placement="bottom left" container="body">
                                                <button class="btn btn-secondary dropdown-toggle mobile" dropdownToggle
                                                    type="button">
                                                    {{ selectedAction || '+966' }}
                                                </button>

                                                <ul *dropdownMenu class="dropdown-menu mobile">
                                                    <li>
                                                        <a class="dropdown-item" href="javascript:;"
                                                            (click)="selectAction('Item 1')">+966</a>
                                                    </li>
                                                    <!-- <li>
                                                    <a class="dropdown-item" href="javascript:;" (click)="selectAction('Item 2')">+011</a>
                                                </li> -->
                                                </ul>
                                            </div>
                                            <input type="text" placeholder="0000 000 00"
                                                class="form-control bg-gray-100 p-3"
                                                [(ngModel)]="submission.phoneNumber" name="phoneNumber" maxlength="10">


                                        </div>
                                        <div class="d-flex justify-content-end mt-1">
                                            <small [class.text-danger]="(submission.phoneNumber?.length || 0) >= 10"
                                                class="text-muted">
                                                {{ submission.phoneNumber?.length || 0 }} / 10
                                            </small>
                                        </div>
                                    </div>
                                    <div class="d-flex gap-2 flex-column mt-6">
                                        <div class="d-flex gap-2 align-items-center">
                                            <span class="font-weight-bolder h6">الفئة</span>
                                        </div>
                                        <div>
                                            <div class="btn-group w-100" dropdown placement="bottom left"
                                                container="body">
                                                <button
                                                    class="btn btn-secondary dropdown-toggle p-3 mt-1 text-left category"
                                                    dropdownToggle type="button">
                                                    {{ selectedCategoryLabel || 'الفئة' }}
                                                </button>

                                                <ul *dropdownMenu class="dropdown-menu suggesions">
                                                    <li>
                                                        <a class="dropdown-item" href="javascript:;"
                                                            (click)="selectSubmissionCategory(1, 'استفسار')">استفسار</a>
                                                    </li>
                                                    <li>
                                                        <a class="dropdown-item" href="javascript:;"
                                                            (click)="selectSubmissionCategory(2, 'شكوى')">شكوى</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>


                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex gap-2 mt-5 flex-column w-100">
                                    <span class="font-weight-bolder h6">الموضوع</span>
                                    <input type="text" placeholder="اكتب موضوعك"
                                        class="form-control bg-gray-100 p-3 w-100" [(ngModel)]="submission.subject"
                                        name="subject" maxlength="200">
                                    <div class="d-flex justify-content-end mt-1">
                                        <small [class.text-danger]="(submission.subject?.length || 0) >= 200"
                                            class="text-muted">
                                            {{ submission.subject?.length || 0 }} / 200
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex gap-2 mt-5 flex-column w-100 ">
                                    <span class="font-weight-bolder h6">كيف يمكننا مساعدتك؟</span>
                                    <textarea placeholder="اكتب رسالتك هنا" class="form-control bg-gray-100 p-3 w-100"
                                        [(ngModel)]="submission.message" name="message" rows="8" maxlength="500"
                                        style="min-height: 200px; resize: vertical;">
                                </textarea>
                                    <div class="d-flex justify-content-end mt-1">
                                        <small [class.text-danger]="(submission.message?.length || 0) >= 500"
                                            class="text-muted">
                                            {{ submission.message?.length || 0 }} / 500
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 mt-7 mt-md-0 ">
                        <div class="info w-xl-500px ml-lg-auto">
                            <div class="d-flex flex-column py-5">
                                <div class="mb-5 d-flex">
                                    <i class="fa fa-phone lightGreen ml-3 fa-2x"></i>
                                    <div class="d-flex flex-column ml-3 mb-2">
                                        <h5 class="font-weight-bolder text-dark mb-0">{{l('ContactCenterNumber')}}</h5>
                                        <span class="d-block mt-2 lightGreen font-weight-bold mr-9" >
                                            {{viewContactUs.contactUs?.contactCenterNumber}}
                                        </span>
                                    </div>
                                </div>
                                <div class="mb-5 d-flex">
                                    <i class="fa fa-envelope lightGreen ml-3 fa-2x"></i>
                                    <div class="d-flex flex-column ml-3 mb-2">
                                        <h5 class="font-weight-bolder text-dark mb-0">{{l('ContactCenterEmailAddress')}}
                                        </h5>
                                        <span class="d-block mt-2 lightGreen font-weight-bold " >
                                            {{viewContactUs.contactUs?.contactCenterEmail}}
                                        </span>
                                    </div>
                                </div>
                                <div class="mb-5 d-flex">
                                    <i class="fa fa-map-marker-alt lightGreen ml-3 fa-2x"></i>
                                    <div class="d-flex flex-column ml-3 mb-2">
                                        <h5 class="font-weight-bolder text-dark mb-0">{{l('Address')}}</h5>
                                        <span class="d-block lightGreen font-weight-bold mr-9"
                                            
                                            >
                                            <span [innerHtml]="viewContactUs.contactUs?.address"></span>
                                    </span>
                                    </div>
                                </div>


                                <div >
                                    <div class="px-5">
                                        <label class="font-size-sm text-dark-50">{{l('ContactCenterLocation')}} </label>
                                        <div style="height: 200px; width: 100%;" leaflet [leafletOptions]="options"
                                            (leafletMapReady)="onMapReady($event)"></div>
                                    </div>
                                </div>

                                <!-- <div class="mt-5">
                                <h5 class="font-weight-bolder text-dark mb-3">تواصل معنا علي قنوات</h5>

                                <div class="d-flex align-items-center icons">
                                    <a href="#" class="social-icon ml-3"><i class="fab fa-youtube"></i></a>
                                    <a href="#" class="social-icon ml-3"><i class="fab fa-whatsapp"></i></a>
                                    <a href="#" class="social-icon ml-3"><i class="fab fa-linkedin-in"></i></a>
                                    <a href="#" class="social-icon ml-3"><i class="fab fa-twitter"></i></a>
                                </div>
                            </div> -->

                            </div>
                        </div>

                    </div>
                </div>




            </div>

            <div class="card-footer d-flex ">
                <button type="button" class="btn btn-outline-light btn-lg px-8" [routerLink]="['/home']">
                    عودة
                </button>
                <button type="button" class="btn text-white  btn-lg px-8" (click)="submit()">
                    ارسال
                </button>
            </div>

        </div>
    </section>

    <static-ftr></static-ftr>
</div>